<template lang="html">
  <div class="details">
    <div class="detailsContent">
      <div class="oneFeedBack" v-if="vote.feedback_1.label">
        <span class="feedbackTitle"  >{{vote.feedback_1.label}}</span>
        <span class="feedbackValue" v-if="vote.feedback_1.value">{{vote.feedback_1.value}}</span>
        <span class="feedbackValue" v-else>{{$t("No feedback given")}}</span>
      </div>

      <div class="oneFeedBack"  v-if="vote.feedback_2.label">
        <span class="feedbackTitle">{{vote.feedback_2.label}}</span>
        <span class="feedbackValue" v-if="vote.feedback_2.value">{{vote.feedback_2.value}}</span>
        <span class="feedbackValue" v-else>{{$t("No feedback given")}}</span>
      </div>

      <div class="oneFeedBack" v-if="vote.feedback_3.label">
        <span class="feedbackTitle"  >{{vote.feedback_3.label}}</span>
        <span class="feedbackValue" v-if="vote.feedback_3.value">{{vote.feedback_3.value}}</span>
        <span class="feedbackValue" v-else>{{$t("No feedback given")}}</span>
      </div>

      <div class="oneFeedBack" v-if="vote.comments">
        <span class="feedbackTitle"  >Comments</span>
        <span class="feedbackValue" v-if="vote">{{vote.comments}}</span>
      </div>


    </div>
  </div>

</template>


<script>
export default {
  name : "FeedbackDetail",
  methods:{
    computedProgress(value) {
         // Make sure progress is between 0 and 100
         return Math.max(0, Math.min(100, (value / 5) * 100));
       },

  },
  computed: {
   // Filter the array passed via props

 },
  props: ["vote"]
}
</script>

<style media="screen" scoped>

.details{
  position: absolute;
  background: #FFF;
  color: #000;
  bottom: 0;
  left: 20px;
  right:20px;
  z-index:99;
  transform: translateY(calc(100% + 10px));
  min-width:300px;
  padding:20px;
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.12);

}

.details .detailsContent{
  display: flex;
  flex-direction: column;
  gap:20px;
  font-size:14px;
  line-height: 20px;
}
.oneFeedBack{
  display:flex;
  flex-direction: column;
  gap:0px;
}

.feedbackTitle{
  font-weight: 700;
  font-size:16px;
  text-transform: none;
}

.feedbackValue{
  font-weight: 400;
  font-size:14px;

text-transform: none;
}


</style>
